import VideoCallMeet from './VideoCallMeet'

export default VideoCallMeet
